import React from 'react';
// import moment from "moment";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Calendar from 'modules/shared/components/_employee-views/Calendar/DatePicker/Calendar';
import EmployeeChipListContainer from 'modules/shared/components/_employee-views/EmployeeChipList/EmployeeChipListContainer';
const InitiativeDialog = props => {
  return (
    <div id="InitiativeDialog">
      <div className="InitiativeDialogTitle">
        {props.initiative?.id ? props.initiative.name : 'New Initative'}
      </div>
      <div className="InitiativeDialogContent">
        <TextField
          onChange={e => {
            props.handleChange(e.target.name, e.target.value);
          }}
          defaultValue={props.initiative?.name}
          name="name"
          required
          autoFocus
          margin="dense"
          id="Name"
          label="Name"
          type="text"
          fullWidth
        />
        <TextField
          onChange={e => {
            props.handleChange(e.target.name, e.target.value);
          }}
          defaultValue={props.initiative?.name}
          name="description"
          autoFocus
          margin="dense"
          id="Name"
          label="Description"
          type="text"
          fullWidth
        />
        <EmployeeChipListContainer
          handleEmployeesChange={employees =>
            props.handleChange(
              'owners',
              employees.map(emp => emp.id)
            )
          }
          fullWidth={true}
          employees={props.initiative?.owners || []}
        />
        <div className="formRow-50">
          <Calendar
            handleChange={date => props.handleChange('startDate', date.toISOString())}
            date={props.initiative?.startDate}
            placeholder="Start Date"
            fullWidth={true}
          />
          <Calendar
            handleChange={date => props.handleChange('endDate', date.toISOString())}
            date={props.initiative?.endDate}
            placeholder="End Date"
            fullWidth={true}
          />
        </div>
        {/* <TagsContainer  /> */}
      </div>

      <div className="InitiativeDialogActions">
        <Button onClick={props.cancel}>Cancel</Button>
        <Button onClick={props.save} disabled={!props.isValid} color="primary">
          {props.initiative?.id ? 'Save' : 'Create'}
        </Button>
      </div>
    </div>
  );
};
export default InitiativeDialog;
